<template>
  <Box>
    <template #handle>
      <Btn @click="$router.go(-1)">返回</Btn>
    </template>
    <template #content>
      <div class="table_main">
        <div class="content">
          <Table :datas="tableData" :heads="tableHead" :loading="loading">
            <template #handle="data">
              <div class="table_cell">
                <span v-if="data.head.handle == 'index'">{{
                    (pageData.page - 1) * pageData.pageSize + data.index
                }}</span>
                <span v-if="data.head.handle == 'sbstate'" :class="['pre']">
                  <span class="_pre" :style="{
                    background: (
                      sbstate.find((a) => a.value == data.data.sbstate) || {}
                    ).color,
                  }"></span>
                  <span>{{ data.data.sbstate }}</span>
                </span>
              </div>
            </template>
          </Table>
          <el-pagination class="page" background layout="total, sizes, prev, pager, next" :total="pageData.total" :page-sizes = "[10, 20, 50, 100]"
            :current-page.sync="pageData.page" :page-size.sync="pageData.pageSize" @size-change="query" @current-change="getList">
          </el-pagination>
        </div>
      </div>
    </template>
  </Box>
</template>

<script>
import { sbstate } from "@/utils/status";
import moment from "moment";
import { upgradedSbList } from "@/api/CollectionSystemSetUpManagement";
export default {
  data() {
    return {
      sbstate,
      loading: false,
      pageData: {
        total: 0,
        page: 1,
        pageSize: 10,
      },
      tableData: [],
      tableHead: [
        {
          label: "序号",
          handle: "index",
          width: 50,
          textAlign: "right",
        },
        {
          prop: "nnc",
          label: "设备编号",
        },
        {
          prop: "xh",
          label: "型号",
        },
        {
          prop: "sbstate",
          label: "设备状态",
          handle: "sbstate",
        },
        {
          prop: "scs",
          label: "生产商",
        },
        {
          prop: "username",
          label: "联系人",
        },
        {
          prop: "phone",
          label: "联系电话",
        },
        {
          prop: "sctime",
          label: "生产日期",
        },
        {
          prop: "upgradeTime",
          label: "升级时间",
        },
        {
          prop: "createUser",
          label: "操作人",
        },
      ],
      addForm: {
        versionTag: "",
        version: "",
        context: "",
        releaseScope: "",
      },
      initAddForm: {},
      tableSelected: [],
    };
  },
  methods: {
    query() {
      this.pageData.page = 1;
      this.getList();
    },
    getList() {
      if (!this.$route.query.id) return;
      this.loading = true
      const params = {
        ...this.queryParams,
        versionInfoId: this.$route.query.id,
        currentPage: this.pageData.page,
        pageSize: this.pageData.pageSize
      };
      upgradedSbList(params)
        .then((res) => {
          this.pageData.total = res.data.count;
          this.tableData = res.data?.list || [];
          this.loading = false
          try {
            this.tableData.forEach((item) => {
              item.sctime = item.sctime ? moment(item.sctime).format("YYYY-MM-DD HH:mm:ss") : '';
              item.upgradeTime = item.upgradeTime ? moment(item.upgradeTime).format("YYYY-MM-DD HH:mm:ss") : '';
            });
          } catch (err) { }
        })
        .catch((err) => {
          this.pageData.total = 0;
          this.tableData = [];
          this.loading = false
        });
    },
  },
  created() {
    this.getList();
  },
};
</script>
